import Vue from 'vue';
import VueCookies from 'vue-cookies';
Vue.use(VueCookies);

export function getToken(state) {
  return Vue.$cookies.get('token');
}

export function getUserIsLogged(state) {
  state.isLogged = Vue.$cookies.isKey('userIsLogged');
  return state.isLogged;
}

export function userIsAParent(state) {
  state.type = Vue.$cookies.get('userType');
  //console.log("Tipo",state.type)
  return state.type === 'parent';
}

export function getUserId(state) {
  state.userData['id'] = Vue.$cookies.get('userId');
  return state.userData['id'];
}

export function getUserName(state) {
  state.userData['name'] = Vue.$cookies.get('userName');
  return state.userData['name'];
}

export function getChildrenIds(state) {
  return state.childrenIds;
}

export function getChildrenCounter(state) {
  state.childrenCounter = Vue.$cookies.get('childCount');
  return state.childrenCounter;
}

export function getChildrenData(state) {
  return state.childrenData;
}

export function getChildSelectedId(state) {
  state.childSelectedId = Vue.$cookies.get('childSelectedId');
  return state.childSelectedId;
}

export function getChildSelectedName(state) {
  state.childSelectedName = Vue.$cookies.get('childSelectedName');
  return state.childSelectedName;
}

export function error(state) {
  return state.error;
}

export function errorMessage(state) {
  return state.errorMessage;
}

export function getParentName(state) {
  state.userData['parentName'] = Vue.$cookies.get('parentName');
  return state.userData['parentName'];
}

export function getParentId(state) {
  state.userData['parentId'] = Vue.$cookies.get('parentId');
  return state.userData['parentId'];
}

export function getGendersList(state) {
  let response = [];
  state.genders.forEach(element => {
    response.push({ value: element.id, text: element.name });
  });

  return response;
}

export function getIsFirstTime(state) {
  let isFirstTime = true;
  state.type = Vue.$cookies.get('userType');
  if (state.type == 'parent') {
    state.childrenCounter = Vue.$cookies.get('childCount');
    isFirstTime = state.childrenCounter == 0;
    //console.log(state.childrenCounter)
  } else {
    state.childFirstTime = Vue.$cookies.get('childFirstTime');
    isFirstTime = state.childFirstTime == 'true';
  }
  return isFirstTime;
}

export function getDarkMode(state) {
  state.dark = Boolean(Vue.$cookies.get('dark') === 'true');
  return state.dark;
}

export function getTheme(state) {
  state.theme = Vue.$cookies.get('theme');
  return state.theme;
}
